import React from 'react';
import './Contractjob.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


const Textcoldescribe4 = () => {
    return(
        <>
        <Container>
            <Row className='textrow'>
                    <Col sm={12} className='textcol'>
                        <h4>Smooth Onboarding</h4>
                        <p>We will make your transition to and from client projects as smooth and easy as possible. Our
                        onboarding process is streamlined and user-friendly.</p>
                    </Col>
                </Row>
            </Container>
        </>
    )
} 

export default Textcoldescribe4